import React, { useRef } from 'react'
import {
  Grid, Typography, Dialog, DialogTitle, DialogContent, Stack,
} from '@mui/material'
import { ClassNameMap, withStyles } from '@mui/styles'
import stylesheet from '../detail-container.stylesheet'
import 'react-calendar/dist/Calendar.css'
import Draggable from 'react-draggable'
import DialogTitleHeaderComponent from '../common/dialog-title-header.component'

interface IProps {
  input: any
  open: boolean
  handleClose: any
  classes: ClassNameMap
}

const ThresholdCardComponent: React.FC<IProps> = ({ input, open, handleClose, classes, }) => {
  const thresholdRef = useRef(null) as any

  const getList = (title: any, val: any) => {
    return <Grid container direction="row" className={classes.evalToxCard}>
      <Grid item>
        <Typography className={classes.evalBoxVal}>{title}</Typography>
      </Grid>
      <Grid item>
        <Typography className={classes.toxicityEvalBoxVal}>
          {val}
        </Typography>
      </Grid>
    </Grid>
  }

  return <>
    {open &&
      <Draggable ref={thresholdRef} defaultPosition={{ x: 80, y: 20 }} handle='.threshold-dialog'>
        <Dialog
          id={`thresholdRef-id`}
          fullWidth={true}
          maxWidth="lg"
          open={open}
          onClose={handleClose}
          hideBackdrop
          disableScrollLock
          sx={{
            position: "absolute",
            left: '10rem',
            top: '8rem'
          }}
        >
          <DialogTitle className={classes.contextualHelpHeader} classes={{ root: 'threshold-dialog' }}>
            <DialogTitleHeaderComponent title={input?.display_name} handleDialogClose={handleClose} />
          </DialogTitle>
          <DialogContent className={`${classes.contextualHelpContext} ${classes.zeroPadding}`}>
            <Stack sx={{ padding: '1rem 1.2rem' }} direction='column'>
              {getList('Title', input.display_name)}
              {getList('Current value', input.current_value)}
              {getList('Value', input.value)}
              {getList('Threshold', input.threshold)}
              {getList('Rationale', '')}
            </Stack>
          </DialogContent>
        </Dialog>
      </Draggable>
    }
  </>
}

export default withStyles(stylesheet)(ThresholdCardComponent)